import { useToast as uT } from "primevue";
import { ToastMessageOptions } from "primevue";
import ToastEventBus from "primevue/toasteventbus";

export const defaultToastMessageOptions: ToastMessageOptions = {
    life: 3000,
};

export function addToast(message: ToastMessageOptions) {
    ToastEventBus.emit("add", { ...defaultToastMessageOptions, ...message });
}

export function useToast() {
    const toast = uT();

    return {
        add(message: ToastMessageOptions) {
            toast.add({ ...defaultToastMessageOptions, ...message });
        },
        remove(message: ToastMessageOptions) {
            toast.remove(message);
        },
        removeGroup(group: string) {
            toast.removeGroup(group);
        },
        removeAllGroups() {
            toast.removeAllGroups();
        },
    };
}
